module.exports = __webpack_public_path__ + "img/img02@2x.025bf5c3.png";